module.exports = __webpack_public_path__ + "static/phone-partner-landscape-a607ae422cb4e40f926a0ab096696c73.png";